import { createFileRoute } from "@tanstack/react-router"
import { AccessAuditPage } from "@/pages/access-audit"

export const Route = createFileRoute("/access")({
	component: AccessAuditPage,
})
